export default __webpack_public_path__ + "static/media/circle-carnation-icon.c77bf433.svg";